import { BaseMutations } from '@/store/base-mutations';
import BrandsState from './state';
import { Brands } from '../types';

export default class BrandsMutations extends BaseMutations<BrandsState> {
  SET_BANNER(banner: string) {
    this.state.banner = banner;
  }

  SET_BRANDS_DESING(design: Brands.Design[]) {
    this.state.design = design;
  }

  SET_BRAND(brand: Brands.Brand) {
    this.state.brand = brand;
  }

  SET_DESIGN_TITLE(design_title: string) {
    this.state.design_title = design_title;
  }

  SET_DESIGN_PAGE_LIST(items: Brands.DesingPageList[]) {
    this.state.design_page_list = items;
  }

  SET_DESIGN_BLOCK(design_block: Brands.DesingBlock[]) {
    this.state.design_block = design_block;
  }

  SET_PARTNERSHIP(partnership: Brands.PartnerShip[]) {
    this.state.partnership = partnership;
  }

  UPD_ACTIVE_ID(id: string | number) {
    this.state.active_id = id;
  }
}
